export function ModalAppDktLogoIcon() {
  return (
    <svg
      width="80"
      height="83"
      viewBox="0 0 80 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="drop-shadow-[0_11.294px_15.059px_rgba(0,0,0,0.12)]"
    >
      <g filter="url(#filter0_d_3747_4837)">
        <rect
          x="7.52942"
          width="64"
          height="64"
          rx="4.78912"
          fill="#3643BA"
          shapeRendering="crispEdges"
        />
        <path
          d="M49.5634 13.0612C34.9054 13.0612 16.6722 28.1594 16.6722 40.6725C16.6722 47.1351 21.6586 50.3946 28.2444 50.3946C33.0802 50.3946 38.9321 48.6337 44.577 45.2432V20.2731C43.0717 22.8394 35.9967 33.1796 30.3142 38.6869C27.4164 41.4967 25.1208 42.7143 23.1451 42.7143C20.9248 42.7143 19.871 41.2158 19.871 38.9866C19.871 28.8712 36.9752 15.7212 48.3027 15.7212C52.9692 15.7212 55.9798 17.7817 55.9798 21.7904C55.9798 25.462 53.4772 30.0701 49.2059 34.3223V42.0587C56.6572 36.1955 61.1167 28.7214 61.1167 22.6896C61.1167 16.3394 56.1491 13.0612 49.5634 13.0612Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3747_4837"
          x="7.15256e-06"
          y="0"
          width="79.0588"
          height="82.8235"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="7.52941"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_3747_4837"
          />
          <feOffset dy="11.2941" />
          <feGaussianBlur stdDeviation="7.52941" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3747_4837"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3747_4837"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
